import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { round } from 'lodash';

@Component({
  selector: 'app-number-cell',
  imports: [DecimalPipe],
  templateUrl: './number-cell.component.html',
  styleUrl: './number-cell.component.scss',
})
export class NumberCellComponent {
  public readonly value = input.required<number | null>();
  public readonly decimalPlaces = input(0);
  public readonly unit = input('');
  public readonly disablePipe = input(false);
  public readonly acceptZero = input(false);

  protected decimalValue = computed(() => {
    if (this.value() == null && !this.acceptZero()) return null;

    return round(
      this.value()! / 10 ** this.decimalPlaces(),
      this.decimalPlaces(),
    );
  });
  protected pipeFormat = computed(() => `1.0-${this.decimalPlaces()}`);
}
